import { bajaActaTribunal, constanciaAnulacion } from "../services/opciones.service";
import { useGeneralAppStore } from "../store/generalAppStore";

const { handlerModal } = useGeneralAppStore.getState();
// export const bajaActaTribunalHandler = async (payload) => {
export const bajaActaTribunalHandler = async (param, setRefetch) => {
  // const result = await bajaActaTribunal(payload);
  const result = await bajaActaTribunal(param, setRefetch);
  if (result) {
    handlerModal({ modal: false, modalName: "baja_tribunal" });
    console.log(result);
  }
};

export const constanciaAnulacionHandler = async (payload, setConstancia) => {
  const result = await constanciaAnulacion(payload);
  if (result) {
    setConstancia(result);
  }
};
